/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'
import { useRcmTableData } from '../../hooks/useRcmTableData'
import Loader from '../shared/Loader'
import { RcmPaginate } from './RcmPaginate'
import { RcmArrowsPaginate } from './RcmArrowsPaginate'

export interface GridWrapperProps {
  GridItemView: React.ComponentType<{ row: any }>
  gridViewClass?: string
  simplePaginate?: boolean
  className?: string
  [key: string]: any
}

export const GridWrapper: React.FC<GridWrapperProps> = ({
  GridItemView,
  gridViewClass,
  simplePaginate,
  className = '',
  ...props
}) => {
  const tableData = useRcmTableData()

  return (
    <div className={gridViewClass}>
      <Loader blocking={tableData.isLoading}>
        <ul className={'gridviewlist'}>
          {tableData.entries.map((item) => (
            <li key={item.id} className={'gridviewitem' + (item.gridItemClass ? ' ' + item.gridItemClass : '')}>
              <GridItemView row={item} />
            </li>
          ))}
        </ul>
        {simplePaginate ? <RcmArrowsPaginate /> : <RcmPaginate />}
      </Loader>
    </div>
  )
}
